import { NotFound } from './NotFound';

export type { TypeNotFoundProps } from './types';
export default NotFound;
